import { VisitorDTO } from "../types/visitor"
import { api } from "./axios"

const baseUrl = '/rest/v1/visitors'

export async function getVisitorsByIds(ids: string[]): Promise<VisitorDTO[]> {
    const res = await api.post(`${baseUrl}/find`, ids)
    return res.data
}